import Vue from 'vue'
import{Button,Icon, Select, Option,MessageBox,Message,Table, TableColumn,Tag} from "element-ui"

const element = {
    install:function(Vue){
        Vue.use(Button),
        Vue.use(Icon);
        Vue.use(Select);
        Vue.use(Option);
        Vue.use(Table);
        Vue.use(TableColumn);
        Vue.use(Tag);
    }
}

Vue.prototype.$confirm = function Confirm(tip, confirmButtonText, cancelButtonText) {
  return new Promise((resolve,reject)=>{
    MessageBox.confirm(
      tip,
      "提示",
      {
        confirmButtonText:confirmButtonText|| "确定",
        cancelButtonText:cancelButtonText|| "取消",
        type: "warning",
      }
    ).then((res)=>{
      resolve()
    }).catch((err)=>{ 
      reject(err)
    }) 
  })
}

const messages = ['success', 'warning', 'info', 'error'];
messages.forEach(type => {
  Message[type] = options => {
    if (typeof options === 'string') {
      options = {
          message: options
      };
      if(type === 'error'){
        options.duration = 2000;
      }else{
        options.duration = 2000;
      }
      options.showClose = false;
    }
    options.type = type;
    return Message(options);
  }
})
Vue.prototype.$message = Message

export default element 